import _extends from "/data/wwwroot/dongliyuanlin.com/web/node_modules/babel-runtime/helpers/extends";
import _regeneratorRuntime from "/data/wwwroot/dongliyuanlin.com/web/node_modules/babel-runtime/regenerator";
import _asyncToGenerator from "/data/wwwroot/dongliyuanlin.com/web/node_modules/babel-runtime/helpers/asyncToGenerator";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapState } from "vuex";
import CommonFooter from "~/components/CommonFooter";
import CommonTitle from "~/components/CommonTitle";
import axios from "axios";
export default {
  name: "index",
  components: {
    CommonFooter: CommonFooter,
    CommonTitle: CommonTitle
  },
  asyncData: function () {
    var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(_ref) {
      var store = _ref.store,
          query = _ref.query;
      var result, results;
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return store.dispatch("getPageData", { id: 12, lang: query.lang });

            case 2:
              result = _context.sent;
              _context.next = 5;
              return store.dispatch("getPageIndex", { lang: query.lang });

            case 5:
              results = _context.sent;
              return _context.abrupt("return", { pageData: result, projectData: results });

            case 7:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, this);
    }));

    function asyncData(_x) {
      return _ref2.apply(this, arguments);
    }

    return asyncData;
  }(),
  data: function data() {
    return {
      videoPlaying: false,
      idx: false,
      top: [{ top: "0px" }, { top: "0px" }, { top: "0px" }, { top: "0px" }],
      isA: false
    };
  },

  watch: {
    videoPlaying: function videoPlaying() {
      return this.$store.state.playing = this.videoPlaying;
    }
  },
  computed: _extends({}, mapState(["winHeight", "flag", 'lang', 'playing']), {
    up: function up() {
      return {
        height: this.winHeight + "px"
      };
    },
    ups: function ups() {
      return {
        height: (this.winHeight - 60) * 2 + "px"
      };
    },
    descPageData: function descPageData() {
      var _this = this;

      return this.projectData.map(function (val, key) {
        return _this.projectData[_this.projectData.length - 1 - key];
      });
    },
    firstPage: function firstPage() {
      return this.pageData.filter(function (val) {
        return val.id === '54';
      });
    },
    thirdPage: function thirdPage() {
      return this.pageData.filter(function (val) {
        return val.id === '55';
      });
    },
    fourPage: function fourPage() {
      return this.pageData.filter(function (val) {
        return val.id === '56';
      });
    },
    pro: function pro() {
      if (this.lang === 'en') {
        return 'Projects';
      } else {
        return '项   目';
      }
    },
    more: function more() {
      if (this.lang === 'en') {
        return 'More';
      } else {
        return '更多项目';
      }
    }
  }),
  methods: {
    videoPlay: function videoPlay() {
      var _this2 = this;

      // let playing = false
      // let header = document.getElementsByID('header')
      var videoItem1 = this.$refs.mobile_video;
      var videoItem2 = this.$refs.mobile_videos;
      console.log(videoItem1);
      // let videoItem1 = document.getElementById('mobile_video')
      // let videoItem2 = document.getElementById('mobile_videos')

      videoItem1.addEventListener('play', function () {
        // header.classList.add('hide')
        _this2.videoPlaying = true;
      }), videoItem1.addEventListener('pause', function () {
        _this2.videoPlaying = false;
      }),

      // 如果事件比较多，可以监听一下视频播放的状态
      // if(playing){
      //     header.classList.add('hide')
      // }else{
      //     header.classList.remove('hide')
      // }

      window.addEventListener('scroll', function () {
        if (window.pageYOffset > 0) {
          videoItem.pause();
        }
      });
    }
  },
  mounted: function mounted() {
    var _this3 = this;

    this.videoPlay();
    function isAndroid() {
      var u = navigator.userAgent;
      if (u.indexOf('Android') > -1 || u.indexOf('Linux') > -1) {
        return true;
      }
    }
    this.isA = isAndroid();
    function isWeixinBrowser() {
      var agent = navigator.userAgent.toLowerCase();
      if (agent.match(/MicroMessenger/i) == "micromessenger") {
        return true;
      } else {
        return false;
      }
    }

    var flag = isAndroid() && isWeixinBrowser();
    if (!isAndroid()) {

      var video = document.querySelector("#mobile_video");
      document.addEventListener("WeixinJSBridgeReady", function () {
        WeixinJSBridge.invoke("getNetworkType", {}, function (e) {
          document.getElementById("mobile_video").play();
        });
      }, false);
      $(window).one("touchstart", function () {
        video.play();
      });

      var promise = document.querySelector("#mobile_video").play();

      if (promise !== undefined) {
        promise.catch(function (error) {
          var video2 = document.querySelector("#mobile_videos"),
              node = document.querySelector(".first-section");
          var imgPc = new Image();
          var imgMb = new Image();

          function add(img, className, src) {
            img.src = src;
            img.classList.add(className);
            img.onload = function () {
              node.appendChild(img);
            };
            img.onclick = function (e) {
              img.style.display = "none";
              video.play();
              video2.play();
            };
            img.ontouchstart = function (e) {
              img.style.display = "none";
              video.play();
              video2.play();
            };
          }
          add(imgPc, "posterPc", "http://cdn.dongliyuanlin.com/video/index-1posterpc.jpg");
          add(imgMb, "posterMb", "http://cdn.dongliyuanlin.com/video/index-1postermb.jpg");
        }).then(function () {});
      }
      document.querySelector(".main-component").onscroll = function () {
        if (document.querySelector(".main-component").scrollTop > _this3.winHeight) {
          document.getElementById("mobile_video").pause();
          document.getElementById("mobile_videos").play();
        } else {
          document.getElementById("mobile_video").play();
          document.getElementById("mobile_videos").pause();
        }
      };
    } else {
      var add = function add(img, className, src, node) {
        img.src = src;
        img.classList.add(className);
        img.onload = function () {
          node.append(img);
        };
      };

      // if (isWeixinBrowser()) {
      //   // 安卓微信视屏播放
      //   let video2 = $("#mobile_videos"),
      //     node = $(".first-section"),
      //     node2 = $(".third-section"),
      //     video1 = $('#mobile_video')
      //   video1.css({ 'height': "auto" })
      //   // video2.attr('poster', 'http://cdn.dongliyuanlin.com/video/index-3mb.png')
      //   var imgPc = new Image();
      //   var imgMb = new Image();
      //   function add(img, className, src, node) {
      //     img.src = src;
      //     img.classList.add(className);
      //     img.onload = function () {
      //       node.append(img);
      //     };
      //   }
      //   add(
      //     imgMb,
      //     "posterMb",
      //     "http://cdn.dongliyuanlin.com/video/index-1postermb.jpg",
      //     node
      //   );
      //   add(
      //     imgPc,
      //     "posterMb",
      //     "http://cdn.dongliyuanlin.com/video/index-3mb.png",
      //     node2
      //   );
      //   let btn = $('<button class="btn-start one"></button>'), btn1 = $('<button class="btn-start two"></button>')

      //   $('.first-section').append(btn)
      //   $('.third-section').append(btn1)

      //   $('.one').click(function () {

      //     document.getElementById("mobile_video").play();
      //   })
      //   $('.two').click(function () {

      //     document.getElementById("mobile_videos").play();
      //   })
      // } else {
      // 安卓视屏播放
      var video2 = $("#mobile_videos"),
          node = $(".first-section"),
          node2 = $(".third-section"),
          video1 = $('#mobile_video');
      var imgPc = new Image();
      var imgMb = new Image();

      add(imgMb, "posterMb", "http://cdn.dongliyuanlin.com/video/index-1postermb.jpg", node);
      add(imgPc, "posterMb", "http://cdn.dongliyuanlin.com/video/index-3mb.png", node2);
      // let btn = $('<a class="btn-start one" href="' + this.firstPage[0].video + '"></a>'), btn1 = $('<a class="btn-start two" href="' + this.thirdPage[0].video + '"></a>'),
      //   container1 = $('<div class="container oneVideo"><span class="x">x</span></div>'), container2 = $('<div class="container twoVideo"><span class="s">x</span></div>')
      // $('.first-section').append(btn).append(container1)
      // $('.third-section').append(btn1).append(container2)

      // $('.one').click(function () {
      //   $('.oneVideo').append(video1).fadeIn('fast')
      //   $('.x').click(function () {
      //     $('.oneVideo').fadeOut('fast')
      //     // video1.css({ 'height': '1px' })
      //     document.getElementById("mobile_video").pause();
      //   })
      //   document.getElementById("mobile_video").play();
      // })
      // $('.two').click(function () {
      //   $('.twoVideo').append(video2).fadeIn('fast')
      //   $('.s').click(function () {
      //     $('.twoVideo').fadeOut('fast')
      //     // video1.css({ 'height': '1px' })
      //     document.getElementById("mobile_video").pause();
      //   })
      //   video2.css({ 'height': 'auto' })
      //   document.getElementById("mobile_videos").play();
      // })
    }
  }
  // $(".main-component").scroll(() => {
  //   if ($(".main-component").scrollTop() === 0 && window.screen.width > 768) {
  //     this.$store.state.top = true;
  //   } else {
  //     this.$store.state.top = false;
  //   }
  // });
  // }

};


//////////////////
// WEBPACK FOOTER
// ./node_modules/babel-loader/lib?{"babelrc":false,"cacheDirectory":true,"presets":[["/data/wwwroot/dongliyuanlin.com/web/node_modules/babel-preset-vue-app/dist/index.common.js",{"targets":{"ie":9,"uglify":true}}]]}!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./pages/index.vue
// module id = ./node_modules/babel-loader/lib/index.js?{"babelrc":false,"cacheDirectory":true,"presets":[["/data/wwwroot/dongliyuanlin.com/web/node_modules/babel-preset-vue-app/dist/index.common.js",{"targets":{"ie":9,"uglify":true}}]]}!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./pages/index.vue
// module chunks = 4